export default "__VITE_ASSET__BY4ZLo_K__"